function findAndAttachValidation(retryCount = 0) {
    const inputField = document.querySelector('textarea[name="ymq[Personalisation]"]');
    const addToCartBtn = document.querySelector('button[name="add"]');
    const buyNowBtn = document.querySelector('shopify-buy-it-now-button button');

    if (inputField) {
        console.log("Textarea found, applying validation.");

        if (!inputField.parentNode.querySelector(".custom-error-msg")) {
            const errorMsg = document.createElement("div");
            errorMsg.classList.add("custom-error-msg");
            errorMsg.style.color = "red";
            errorMsg.style.fontSize = "14px";
            errorMsg.style.marginTop = "5px";
            errorMsg.style.display = "none";
            errorMsg.style.whiteSpace = "nowrap";

            const wrapper = document.createElement("div");
            wrapper.style.position = "relative";
            inputField.parentNode.insertBefore(wrapper, inputField);
            wrapper.appendChild(inputField);
            wrapper.appendChild(errorMsg);

            const validateInput = () => {
                const value = inputField.value.trim();
                const maxLength = 15;
                const specialCharRegex = /[^a-zA-Z0-9\s]/;
                const emojiRegex = /[\p{Extended_Pictographic}]/u;
                let errors = [];

                if (value.length > maxLength) errors.push("Maximum 15 characters allowed.");
                if (specialCharRegex.test(value)) errors.push("Special characters are not allowed.");
                if (emojiRegex.test(value)) errors.push("Emojis are not allowed.");

                if (errors.length > 0) {
                    errorMsg.innerHTML = errors.join("<br>");
                    errorMsg.style.display = "block";
                    disableButtons();
                } else {
                    errorMsg.style.display = "none";
                    enableButtons();
                }
            };

            const disableButtons = () => {
                [addToCartBtn, buyNowBtn].forEach((btn) => {
                    if (btn) {
                        btn.disabled = true;
                        btn.style.opacity = "0.5";
                        btn.style.cursor = "not-allowed";
                        btn.style.pointerEvents = "none";
                    }
                });
            };

            const enableButtons = () => {
                const value = inputField.value.trim();
                if (value === "" || !errorMsg.innerHTML) {
                    [addToCartBtn, buyNowBtn].forEach((btn) => {
                        if (btn) {
                            btn.disabled = false;
                            btn.style.opacity = "1";
                            btn.style.cursor = "pointer";
                            btn.style.pointerEvents = "auto";
                        }
                    });
                }
            };

            inputField.addEventListener("input", validateInput);
            inputField.addEventListener("blur", validateInput);

            validateInput();
        }
    } else if (retryCount < 20) {
        console.warn(`Retrying to find the textarea... Attempt ${retryCount + 1}`);
        setTimeout(() => findAndAttachValidation(retryCount + 1), 500);
    } else {
        console.error("Textarea not found after multiple attempts.");
    }
}

document.addEventListener("DOMContentLoaded", () => findAndAttachValidation());
document.addEventListener('shopify:section:load', () => findAndAttachValidation());